
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 0h512v341.3H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M0 215.2h211.5v126.1H0z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M0 0h211.5v126.2H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M300.5 0H512v126.2H300.5z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M300.5 215.2H512v126.1H300.5z"}}),_c('g',{attrs:{"stroke":"#FFF","stroke-width":"5","stroke-miterlimit":"10"}},[_c('path',{attrs:{"fill":"#0052B4","d":"M256 130h-49.9v49.4s19.5 6 49.9 6V130z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"}})])])
          )
        }
      }
    